const numberEls = document.querySelectorAll('.stats-bar__number--animated');

if (numberEls.length > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const animateCount = (el) => {
    const raw = el.textContent.trim();
    const match = raw.match(/^([\d,]+)/);
    if (!match) return;

    const target = parseInt(match[1].replace(/,/g, ''), 10);
    if (Number.isNaN(target)) return;

    const suffix = raw.slice(match[1].length);
    const duration = 1400;
    let start = null;

    const step = (timestamp) => {
      if (start === null) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(eased * target);
      el.textContent = current.toLocaleString('en-US') + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = raw;
      }
    };

    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.4 }
  );

  numberEls.forEach((el) => observer.observe(el));
}
